import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import FileUploader from '@jumbo/Dashboards/Media/FileUploader';
import ImagePicker from './ImagePicker';
import { Box, Grid, Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  optionText: {
    width: '17px',
    marginRight: '16px',
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
}));

export default function TestImageElement({ text, value, handleChange }) {
  const [openFileUploader, setOpenFileUploader] = useState(false);
  const classes = useStyles();
  return (
    <React.Fragment>
      <Grid item xs={12} md={6}>
        <Box display={'flex'} alignItems={'center'}>
          <Typography className={classes.optionText}>{text}</Typography>
          <ImagePicker cover={value} handlePick={() => setOpenFileUploader(true)} handleRevome={() => handleChange('')} />
        </Box>
      </Grid>
      <FileUploader
        selectMode
        open={openFileUploader}
        handleClose={() => setOpenFileUploader(false)}
        handleSelect={selected => handleChange(selected)}
        selectedItem={value}
        imageSelector={true}
      />
    </React.Fragment>
  );
}
